import { STATUS_CODE } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ProjetosComponentesProvider } from "src/providers/ProjetosComponentesProvider";
import { ComponenteProjetoComQuantidade, ProjetoComponente } from "../edicao/types";

const projetosComponentesProvider = new ProjetosComponentesProvider();

export const verificarRestricoesProjeto = async (projetoId: number, componentes: ProjetoComponente[]): Promise<Pick<ComponenteProjetoComQuantidade, "nome" | "categoria_componentes_id">[]> => {
  const restricoesResult = await projetosComponentesProvider.verificarRestricoesProjeto(projetoId);

  if (restricoesResult.statusCode !== STATUS_CODE.OK) {
    notifierStore.setNotifier({
      content: 'Erro ao verificar restrições do projeto',
      onClose: () => notifierStore.setOpen(false),
      timeOut: 6000,
      title: 'Atenção',
    })

    notifierStore.setOpen(true)
    return [];
  }

  const componentesFaltantes = restricoesResult.data || [];
  if (!componentesFaltantes.length) return [];

  const faltantes: Pick<ComponenteProjetoComQuantidade, "nome" | "categoria_componentes_id">[] = []
  
  componentesFaltantes.forEach(itemFaltante => {
    const componente = componentes.find(item => item.componente.id === itemFaltante.componente_id);
    if (componente && componente.componente) {
      faltantes.push({ nome: componente.componente.nome, categoria_componentes_id: componente.componente.categoria_componentes_id });
    }
  })

  return faltantes;
}